import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  container: {
    padding: '20px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  tableContainer: {
    height: 'calc(100vh - 280px)',
    minHeight: '600px',
    display: 'flex',
    flexDirection: 'column',
  },
  tableWrapper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    '& > div': {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    '& .MuiPaper-root': {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    '& .MTableToolbar-root': {
      flexShrink: 0,
    },
    '& .MTableBody-root': {
      flex: 1,
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
    },
    '& .MTableContainer-root': {
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
    },
  },
  tableHeader: {
    backgroundColor: '#F5F5F5',
  },
  tableRow: {
    '&:nth-of-type(even)': {
      backgroundColor: '#FAFAFA',
    },
    '&:nth-of-type(odd)': {
      backgroundColor: '#FFFFFF',
    },
  },
}))

export { useStyles }
